/**
 * 应用 Logo
 */
import { Village } from '@/constants';
import { ReadyContext } from '@/providers/ReadyProvider';
import React, { useContext } from 'react';

export interface AppLogoProps {
  size?: number;
}

export default function AppLogo({
  size = 20,
  ...props
}: AppLogoProps & React.ImgHTMLAttributes<HTMLImageElement>) {
  const { profile } = useContext(ReadyContext);
  const appName = process.env.REACT_APP_NAME || '比斯特GWC-PC';
  const logoUrl = `/resources/images/logo-${Village[profile?.shopping_village]}.png`;

  return <img src={logoUrl} alt={`${appName} logo`} width={size} height={size} {...props} />;
}
